module.exports = __webpack_public_path__ + "img/archive-icon.df16bc43.svg";